'use strict';

/**
 * Webform
 * */

import { uxRequest } from "Libs/Request/main.js";


const HTMLForm = `
<div class="form-description">
	<span id="popup-error-message" class="error"></span>
</div>
<div id="popup-form-header" class="form-description"></div>
<div id="popup-form-result" class="form-description"></div>
<form id="quick-order">
	<input id="popup-form-contact" name="contact" placeholder="e-mail или телефон *" type="text">
	<input value="" name="from_page" type="hidden" id="popup_from_page">
	<textarea id="popup-form-message" name="message" placeholder="Ваше сообщение*"></textarea>
	<div class="flex-wrapper">
		<input id="agree-checkbox" name="agree" value="1" type="checkbox">
		<label for="agree-checkbox">(*) Нажимая кнопку «Отправить», я даю своё cогласие на сбор и обработку моих персональных данных в соответствии с <a href="/files/legal/private_information_policy.pdf" target="_blank">Политикой конфиденциальности</a>
		</label>
	</div>
	<div data-yandex-captcha="data-yandex-captcha"></div>
	<input disabled="disabled" name="btnSubmit" value="Отправить" type="submit">
</form>
`;


export class WebFormCls {
	constructor(PopupWindow, options = {}) {

		this.captchaStatus = false;

		this.options = Object.assign({
			'pageId': 0,
			'welcomeText':'Пожалуйста, укажите контактные данные, чтобы мы могли с вами связаться',
			'agreeText':`(*) Нажимая кнопку «Отправить», я даю своё cогласие на сбор и обработку моих персональных данных в соответствии с <a href="/doc/privacy-policy/" target="_blank" >Политикой конфиденциальности</a>`,
			'agreeError': 'Пожалуйста, ознакомьтесь с политикой обработки персональных даных',
			'fillError': 'Пожалуйста, укажите контактные данные',
		}, options);



		this.PopupWindow = PopupWindow;
		this.PopupWindow.empty();

		this.contentWrapper = this.PopupWindow.getContentWrapper();


		this.contentWrapper.innerHTML = HTMLForm;


		this.errorMessage = this.contentWrapper.querySelector('#popup-error-message');
		this.header = this.contentWrapper.querySelector('#popup-form-header');
		this.resultMessage = this.contentWrapper.querySelector('#popup-form-result');
		this.quickOrder = this.contentWrapper.querySelector('#quick-order');
		
		let hidden = this.contentWrapper.querySelector('#popup_from_page');
		let labelAgree = this.contentWrapper.querySelector('label[for="agree-checkbox"');
		let fieldContact = this.contentWrapper.querySelector('#popup-form-contact');

		//TODO undefined
		hidden.setAttribute('value', this.options.pageId);

		this.textarea = this.contentWrapper.querySelector('#popup-form-message');
		this.fieldAgree = this.contentWrapper.querySelector('#agree-checkbox');
		this.submit = this.contentWrapper.querySelector('input[type="submit"]');


		labelAgree.innerHTML = this.options.agreeText;


		this.submit.setAttribute("disabled", "disabled");

		



		if (fieldContact.value.length > 3) {
			this.submit.removeAttribute("disabled");
			console.log(fieldContact.value.length);
		}

		this.resultMessage.textContent = this.options.welcomeText;

		fieldContact.addEventListener('keyup', (e) => {
			if (fieldContact.value.length > 3) {
				this.submit.removeAttribute("disabled");
			} else {
				this.submit.setAttribute("disabled", "disabled");
			}
		})


		fieldContact.addEventListener('click', (e) => {
			if (fieldContact.value.length > 3) {
				this.submit.removeAttribute("disabled");
			} else {
				this.submit.setAttribute("disabled", "disabled");
			}
		})



		

		const sendForm  = () => {
			//e.preventDefault();

			console.log("1");


			if (!this.fieldAgree.checked) {
				this.errorMessage.textContent = this.options.agreeError;
								this.resultMessage.textContent = '';
								this.PopupWindow.status = 'popup-error';

				return false;
			}

			

			if (fieldContact.value.length < 3) {

				this.errorMessage.textContent = this.options.fillError;
								this.resultMessage.textContent = '';
								this.PopupWindow.status = 'popup-error';

				return false;
			}

			console.log("2");


			this.PopupWindow.status = 'popup-waiting';

			let loader = document.createElement('div');
			loader.classList.add('loader');
			this.PopupWindow.contentWrapper.append(loader);

			this.resultMessage.textContent = 'Отправляем сообщение...';



			let data = new FormData(this.quickOrder);

			console.log("3");

			function sendXHR() {
				uxRequest({
					'url': '/webforms/sendme.html', 
					'data': data, 
					'method': 'POST'
				}).then(
					(result) => {

						loader.remove();

						try {
							result = JSON.parse(result.response);
							result = result.result;					

							if (typeof result.error != 'undefined') {//if exist "error" prop
								//this.PopupWindow.tabs.fireTab('order-form');	
								this.errorMessage.textContent = result.error;
								this.resultMessage.textContent = '';
								this.PopupWindow.status = 'popup-error';


							} else {
								//this.PopupWindow.tabs.fireTab('order-form-result');
								this.errorMessage.textContent = '';
								this.resultMessage.textContent = 'Ваше обращение отправлено. Менеджер свяжется с вами в ближайшее время';
								this.PopupWindow.status = 'popup-success';
								window.smartCaptcha.reset();
								this.captchaStatus = false;
							}						

						} catch (e) {
							throw {
						        name: 'Server Error!',
						        message: 'Server Error'
						    }
						}						
					}			
				).catch((err) => {
					//this.PopupWindow.tabs.fireTab('order-form');
					this.errorMessage.textContent = 'Не отправлено! Ошибка на сервере. Позвоните по телефону или попробуйте написать позже';
					this.PopupWindow.status = 'popup-error';
					this.PopupWindow.contentWrapper.classList.remove('popup-waiting');
				});
			}

			setTimeout(sendXHR.bind(this), 1500);

		}

		this.attacheYandexSmartCaptcha(sendForm);

		this.isOnSubmit = false;



		this.quickOrder.addEventListener('submit', (event) => {
			event.preventDefault();

			if (!window.smartCaptcha) {
				console.error("no yandex captcha");
				return;
			}

			this.isOnSubmit = true;
	        

	        if (!this.captchaStatus) {
	        	//console.log("444444", this.captchaStatus);
	        	//this.errorMessage.textContent = 'Не отправлено! Пройдите каптчу и отправьте сообщение повторно';
				//this.PopupWindow.status = 'popup-error';
				//this.PopupWindow.contentWrapper.classList.remove('popup-waiting');
				
				const captchaId = this.quickOrder.querySelector('[name="captcha-widget-id"]').value;
	        	window.smartCaptcha.execute(captchaId);
	        	//console.log("66666", this.captchaStatus);
	        }
	        else {
	        	sendForm();

		        console.log("12111", this.captchaStatus);

		        this.isOnSubmit = false;
		    }

		})


	}

	setHeader(string) {
		this.header.textContent = string;
	}

	setContent(string) {
		this.textarea.textContent = string;
	}

	reset() {
		//this.PopupWindow.tabs.fireTab('order-form');
		this.PopupWindow.status = 'popup-wakeup';
		this.submit.setAttribute("disabled", "disabled");
		this.resultMessage.textContent = this.options.welcomeText;
	}

	check() {

	}


	attacheYandexSmartCaptcha(sendForm) {

		const form = this.quickOrder;

		const captchaContainer = this.quickOrder.querySelector("[data-yandex-captcha]");

		const captchaId = window.smartCaptcha.render(captchaContainer, {
					sitekey: window.YandexSmartCaptchaKey,
					invisible: true, // Сделать капчу невидимой,
					//test: true,
					hl: 'ru',
					callback: (token)=> {
						console.log("999999", this.captchaStatus);

						if (typeof token === "string" && token.length > 0) {
			       			this.captchaStatus = true;
			       			//this.quickOrder.submit();

			       			console.log("0000000", this.captchaStatus);

			       			if (this.isOnSubmit) {
			       				sendForm();
			       				//this.isOnSubmit = false;
			       			}
					    } else {
					    	this.captchaStatus = false;
					    	this.errorMessage.textContent = 'Не отправлено! Ошибка проверки каптчи. Позвоните по телефону или попробуйте написать позже';
							this.PopupWindow.status = 'popup-error';
							this.PopupWindow.contentWrapper.classList.remove('popup-waiting');
							console.log("2222222", this.captchaStatus);
					    }
					},
				});

		const unsubscribe = window.smartCaptcha.subscribe(
	        captchaId,
	        'token-expired',
	        () => {this.captchaStatus = false; console.log('token is expired');}
	      );



		const captchaIdInput = document.createElement("input");
        captchaIdInput.type = 'hidden';
        captchaIdInput.name = "captcha-widget-id";
        captchaIdInput.value = captchaId;

        form.appendChild(captchaIdInput);

        captchaContainer.setAttribute('installed', 'installed');


		
	}


}


